
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/7-small-business-owners-share-their-thoughts-on-community-support",
      function () {
        return require("private-next-pages/blog/7-small-business-owners-share-their-thoughts-on-community-support.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/7-small-business-owners-share-their-thoughts-on-community-support"])
      });
    }
  